import React from 'react';
import propTypes2 from 'prop-types';

import { areBoundsEqual } from '../utils/areBoundsEqual';
import { camelize } from '../utils/String';

const evtNames = ['click', 'mouseout', 'mouseover'];

const wrappedPromise = function () {
    const wrappedPromise = {},
        promise = new Promise(function(resolve, reject) {
            wrappedPromise.resolve = resolve;
            wrappedPromise.reject = reject;
        });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
}

export class Rectangle extends React.Component {
    componentDidMount() {
        this.rectanglePromise = wrappedPromise();
        this.renderRectangle();
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.map !== prevProps.map ||
            !areBoundsEqual(this.props.bounds, prevProps.bounds)
        ) {
            if (this.rectangle) {
                this.rectangle.setMap(null);
            }
            this.renderRectangle();
        }
    }

    componentWillUnmount() {
        if (this.rectangle) {
            this.rectangle.setMap(null);
        }
    }

    renderRectangle() {
        const {
            map,
            google,
            bounds,
            strokeColor,
            strokeOpacity,
            strokeWeight,
            fillColor,
            fillOpacity,
            ...props
        } = this.props;

        if (!google) {
            return null;
        }

        const params = {
            map,
            bounds,
            strokeColor,
            strokeOpacity,
            strokeWeight,
            fillColor,
            fillOpacity,
            ...props
        };

        this.rectangle = new google.maps.Rectangle(params);

        evtNames.forEach(e => {
            this.rectangle.addListener(e, this.handleEvent(e));
        });

        this.rectanglePromise.resolve(this.rectangle);
    }

    getRectangle() {
        return this.rectanglePromise;
    }

    handleEvent(evt) {
        return (e) => {
            const evtName = `on${camelize(evt)}`
            if (this.props[evtName]) {
                this.props[evtName](this.props, this.rectangle, e);
            }
        }
    }

    render() {
        return null;
    }
}

Rectangle.propTypes2 = {
    bounds: propTypes2.object,
    strokeColor: propTypes2.string,
    strokeOpacity: propTypes2.number,
    strokeWeight: propTypes2.number,
    fillColor: propTypes2.string,
    fillOpacity: propTypes2.number
}

Rectangle.defaultProps = {
    name: 'Rectangle'
}
